/* src/app/components/indicator-sectors/indicator-sector-add-edit/indicator-sector-add-edit.component.css */
/*# sourceMappingURL=indicator-sector-add-edit.component.css.map */
